import React, { useState } from "react";
import Chart from "react-apexcharts";
import { CHART_COLORS, fmtCurrency } from "./analyticsUtils";

const TopMoversChart = ({ topMovers = [], bottomMovers = [], loading }) => {
    const [view, setView] = useState("top");
    const rows = view === "top" ? topMovers : bottomMovers;
    const data = rows.map((r) => r.units);
    const labels = rows.map((r) =>
        r.description?.length > 26 ? `${r.description.slice(0, 26)}…` : r.description
    );
    const hasData = data.some((v) => v > 0) || (view === "bottom" && rows.length > 0);

    const options = {
        chart: { toolbar: { show: false }, fontFamily: "inherit" },
        colors: [view === "top" ? CHART_COLORS.green : CHART_COLORS.amber],
        plotOptions: { bar: { horizontal: true, borderRadius: 4, barHeight: "62%" } },
        dataLabels: { enabled: true, style: { fontSize: "11px", colors: ["#fff"] } },
        grid: { borderColor: "#eef2f7", strokeDashArray: 4 },
        xaxis: {
            categories: labels,
            labels: { style: { colors: "#94a3b8", fontSize: "11px" } },
        },
        yaxis: { labels: { style: { colors: "#475569", fontSize: "11px" } } },
        tooltip: {
            y: {
                formatter: (val, opts) => {
                    const row = rows[opts.dataPointIndex];
                    return `${val} units · ${fmtCurrency(row?.revenue)}`;
                },
            },
        },
    };

    return (
        <div className="bg-white rounded-2xl shadow-1 p-4 h-full">
            <div className="flex items-center justify-between mb-2">
                <h3 className="font-bold text-slate-800 text-[15px]">
                    {view === "top" ? "Best Sellers" : "Slowest Movers"}
                </h3>
                <div className="flex rounded-lg bg-slate-100 p-0.5 text-[12px] font-semibold">
                    <button
                        onClick={() => setView("top")}
                        className={`px-3 py-1 rounded-md ${
                            view === "top" ? "bg-white shadow text-slate-800" : "text-slate-500"
                        }`}
                    >
                        Top
                    </button>
                    <button
                        onClick={() => setView("bottom")}
                        className={`px-3 py-1 rounded-md ${
                            view === "bottom" ? "bg-white shadow text-slate-800" : "text-slate-500"
                        }`}
                    >
                        Bottom
                    </button>
                </div>
            </div>
            {loading ? (
                <div className="h-[320px] flex-center text-slate-400 text-[13px]">Loading…</div>
            ) : hasData ? (
                <Chart options={options} series={[{ name: "Units", data }]} type="bar" height={320} />
            ) : (
                <div className="h-[320px] flex-center text-slate-400 text-[13px]">
                    No sales recorded in this period.
                </div>
            )}
        </div>
    );
};

export default TopMoversChart;
